import React from 'react';
import { Microphone, User, Calendar, MapPin, Tag } from '@phosphor-icons/react';

export default function InterviewModule({ metadata, onChange}) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Interviewee */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <User size={16} />
          Interviewee (साक्षात्कारकर्ता) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.interviewee || ''}
          onChange={(e) => handleChange('interviewee', e.target.value)}
          placeholder="Name of the person being interviewed"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Interviewee Title/Profession */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Title / Profession (पद / पेशा)
        </label>
        <input
          type="text"
          value={metadata.interviewee_title || ''}
          onChange={(e) => handleChange('interviewee_title', e.target.value)}
          placeholder="e.g., Renowned Poet, Author, Literary Critic"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Interview Date & Location */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <Calendar size={16} />
            Interview Date
          </label>
          <input
            type="date"
            value={metadata.interview_date || ''}
            onChange={(e) => handleChange('interview_date', e.target.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <MapPin size={16} />
            Location
          </label>
          <input
            type="text"
            value={metadata.location || ''}
            onChange={(e) => handleChange('location', e.target.value)}
            placeholder="City, Venue"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
      </div>

      {/* Interview Type */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Microphone size={16} />
          Interview Type (प्रकार)
        </label>
        <select
          value={metadata.interview_type || ''}
          onChange={(e) => handleChange('interview_type', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select type...</option>
          <option value="in_person">In-Person</option>
          <option value="phone">Phone</option>
          <option value="video">Video Call</option>
          <option value="email">Email</option>
          <option value="written">Written Q&A</option>
        </select>
      </div>

      {/* Topics Covered */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Main Topics Covered (मुख्य विषय)
        </label>
        <textarea
          value={metadata.topics || ''}
          onChange={(e) => handleChange('topics', e.target.value)}
          placeholder="Key topics discussed in the interview..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Key Highlights */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Microphone size={16} weight="fill" className="text-orange-500" />
          Key Highlights (महत्वपूर्ण बिंदु)
        </label>
        <textarea
          value={metadata.highlights || ''}
          onChange={(e) => handleChange('highlights', e.target.value)}
          placeholder="Notable quotes or important points from the interview..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={4}
        />
      </div>

      {/* Duration */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Interview Duration
        </label>
        <input
          type="text"
          value={metadata.duration || ''}
          onChange={(e) => handleChange('duration', e.target.value)}
          placeholder="e.g., 45 minutes"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>
    </div>
  );
}
